import type { ReactNode } from "react";
import {
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import type { EtablissementPublic } from "models";
import TelephoneSpan from "components/Span/TelephoneSpan";
import AdresseSpan from "components/Span/AdresseSpan";
import type { SdeappsError } from "utils/errorHandling";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";

interface EluContactInformationsPubliquesProps {
  etablissement: EtablissementPublic | undefined;
  isLoading: boolean;
  etablissementError: SdeappsError | undefined;
}

function EluContactInformationsPubliques({
  etablissement,
  isLoading,
  etablissementError,
}: Readonly<EluContactInformationsPubliquesProps>): ReactNode {
  return (
    <Grid container size={12}>
      <Grid size={{ xs: 12, md: 6, lg: 4 }}>
        <List dense>
          <ListItem>
            <ListItemIcon>
              <CallOutlinedIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ fontWeight: "600" }}>Téléphone</Typography>
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <TelephoneSpan
                telephone={etablissement?.telephone}
                label="Professionnel"
                isLoading={isLoading}
                error={etablissementError != null}
                hasLink
              />
            </ListItemText>
          </ListItem>
        </List>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 4 }}>
        <List dense>
          <ListItem>
            <ListItemIcon>
              <MailOutlinedIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ fontWeight: "600" }}>Adresse</Typography>
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <AdresseSpan
                adresse={etablissement?.adresse}
                nom={etablissement?.nom}
                isLoading={isLoading}
                error={etablissementError != null}
              />
            </ListItemText>
          </ListItem>
        </List>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 4 }}>
        <List dense>
          <ListItem>
            <ListItemIcon>
              <AlternateEmailOutlinedIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ fontWeight: "600" }}>E-mail Mairie</Typography>
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              {isLoading && <Skeleton />}
              <Link href={"mailto:" + etablissement?.email}>{etablissement?.email}</Link>
            </ListItemText>
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
}

export default EluContactInformationsPubliques;
